import React from 'react'
import * as mpTdd from '../../mixpanel/frags/tripleDotDropdown'

class TripleDotDropdown extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      open: false
    }
  }

  render () {
    const {app} = this.props
    const {open} = this.state
    const classDropdown = open ? 'dropdown open' : 'dropdown'
    return <div className={classDropdown}>
      <button className='btn btn-default btn-no-border' onClick={this._onClickDot} type='button'>
        <img className={'three-dot-img'}
          src={'https://i.gojekapi.com/darkroom/moka/v2/images/static/open-platform/api-ext-assets/static/more.svg'} />
      </button>
      <ul className='dropdown-menu dropdown-menu-right dropdown-t-dot' aria-labelledby='dropdown-actions'>
        <li>
          <a className='' onClick={this._onClickEdit}>
            Edit
          </a>
        </li>
        <li>
          <a className='' data-apptitle={`${app.name}`} data-appuid={`${app.uid}`} data-toggle='modal'
            data-href={`/oauth/applications/${app.id}`} data-target='#confirm-delete' href='#'
            onClick={this._onClickDelete}>
            Delete
          </a>
        </li>
      </ul>
    </div>
  }

  _onClickDot = () => {
    const {app} = this.props
    mpTdd.toggleDropdown({uid: app.uid, name: app.name})
    this._toogle()
  }

  _onClickEdit = () => {
    const {app} = this.props
    mpTdd.clickEdit({uid: app.uid, name: app.name})
    this._toogle()
    setTimeout(function () {
      window.location = `/oauth/applications/${app.id}/edit`
    }, 500)
  }

  _onClickDelete = () => {
    const {app} = this.props
    mpTdd.clickDelete({uid: app.uid, name: app.name})
    this._toogle()
  }

  _toogle = () => {
    const {open} = this.state
    this.setState({open: !open})
  }
}

export default TripleDotDropdown



// WEBPACK FOOTER //
// app/javascript/components/frags/TripleDotDropdown/TripleDotDropdown.js